import { render, staticRenderFns } from "./personToCover.vue?vue&type=template&id=1d14d21a&"
import script from "./personToCover.vue?vue&type=script&lang=ts&"
export * from "./personToCover.vue?vue&type=script&lang=ts&"
import style0 from "./personToCover.vue?vue&type=style&index=0&id=1d14d21a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports